import { createContext } from 'react';

const ErrorMessageContext = createContext();
const UserLoginInputContext = createContext();
const NavigationContext = createContext();
const HasPortalAccess = createContext(false);
const ThemeContext = createContext();

export {
  UserLoginInputContext,
  ErrorMessageContext,
  NavigationContext,
  HasPortalAccess,
  ThemeContext
};
